var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCircleRedCircleXMarkIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 50,
    viewBox: "0 0 51 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13376_59543)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.15
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 25.5,
    cy: 25,
    r: 25,
    fill: "#DF5031"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.3889 24L20.5 20.1111L21.6111 19L25.5 22.8889L29.3889 19L30.5 20.1111L26.6111 24L30.5 27.8889L29.3889 29L25.5 25.1111L21.6111 29L20.5 27.8889L24.3889 24Z",
    fill: "#DF5031"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13376_59543"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleRedCircleXMarkIcon);
export default __webpack_public_path__ + "static/media/CircleRedCircleXMarkIcon.5c968b876a1370f4427b98dd0a795044.svg";
export { ForwardRef as ReactComponent };